import final from "./final"
import minting from "./minting"

$fx.params([
  {
    id: "positionX",
    name: "X position",
    type: "number",
    update: "code-driven",
    default: 3,
    options: {
      min: -250,
      max: 250,
      step: 0.000001,
    },
  },
  {
    id: "positionY",
    name: "Y position",
    type: "number",
    update: "code-driven",
    default: 1.5,
    options: {
      min: -250,
      max: 250,
      step: 0.000001,
    },
  },
  {
    id: "positionZ",
    name: "Z position",
    type: "number",
    update: "code-driven",
    default: 3,
    options: {
      min: -250,
      max: 250,
      step: 0.000001,
    },
  },

  {
    id: "rotationX",
    name: "X rotation",
    type: "number",
    update: "code-driven",
    default: 0.5,
    options: {
      min: -Math.PI,
      max: Math.PI,
      step: 0.000001,
    },
  },
  {
    id: "rotationY",
    name: "Y rotation",
    type: "number",
    update: "code-driven",
    default: 0.5,
    options: {
      min: -Math.PI,
      max: Math.PI,
      step: 0.000001,
    },
  },
  {
    id: "rotationZ",
    name: "Z rotation",
    type: "number",
    update: "code-driven",
    default: 0.5,
    options: {
      min: -Math.PI,
      max: Math.PI,
      step: 0.000001,
    },
  },
  {
    id: "lookAtX",
    name: "Origin X",
    type: "number",
    update: "code-driven",
    default: 0,
    options: {
      min: -250,
      max: 250,
      step: 0.000001,
    },
  },
  {
    id: "lookAtY",
    name: "Origin Y",
    type: "number",
    update: "code-driven",
    default: 0,
    options: {
      min: -250,
      max: 250,
      step: 0.000001,
    },
  },
  {
    id: "lookAtZ",
    name: "Origin Z",
    type: "number",
    update: "code-driven",
    default: 0,
    options: {
      min: -250,
      max: 250,
      step: 0.000001,
    },
  },

  {
    id: "rectLightPosition",
    name: "Monolith Position",
    type: "number",
    update: "code-driven",
    default: -5,
    options: {
      min: -100,
      max: 100,
      step: 0.05,
    },
  },
  {
    id: "rectLightWidth",
    name: "Monolith Width",
    type: "number",
    update: "code-driven",
    default: 5,
    options: {
      min: 0,
      max: 100,
      step: 0.5,
    },
  },
  {
    id: "rectLightHeight",
    name: "Monolith Height",
    type: "number",
    update: "code-driven",
    default: 10,
    options: {
      min: 0,
      max: 100,
      step: 0.5,
    },
  },
])

document.body.classList.add($fx.context)

if ($fx.context === "minting") {
  minting() 
}
else {
  final()
}